/* ============================================================
   HappyHemp – Artikel JavaScript v3
   Datei: assets/custom.js (komplett ersetzen)
   ============================================================ */

(function () {
  'use strict';

  const articleContent = document.getElementById('hh-article-content');
  if (!articleContent) return;

  const h2s = articleContent.querySelectorAll('h2');
  if (h2s.length === 0) return;

  /* ---- 1. H2 IDs setzen ---- */
  h2s.forEach(function (h2, index) {
    h2.id = 'hh-section-' + index;
  });

  /* ---- 2. TOC LINKS GENERIEREN (Desktop + Mobile) ---- */
  const tocDesktopNav = document.getElementById('hh-toc-desktop-nav');
  const tocMobileNav = document.getElementById('hh-toc-mobile-list-nav');

  function createTocLink(h2, index) {
    const id = 'hh-section-' + index;
    const text = h2.textContent.trim();
    const link = document.createElement('a');
    link.href = '#' + id;
    link.textContent = text;
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.getElementById(id);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    return link;
  }

  h2s.forEach(function (h2, index) {
    if (tocDesktopNav) tocDesktopNav.appendChild(createTocLink(h2, index));
    if (tocMobileNav) tocMobileNav.appendChild(createTocLink(h2, index));
  });

  /* ---- 3. AKTIVER TOC-EINTRAG BEIM SCROLLEN ---- */
  const scrollObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        const activeId = entry.target.id;
        document.querySelectorAll('#hh-toc-desktop-nav a, #hh-toc-mobile-list-nav a').forEach(function (link) {
          link.classList.toggle('is-active', link.getAttribute('href') === '#' + activeId);
        });
      }
    });
  }, { rootMargin: '-15% 0px -75% 0px', threshold: 0 });

  h2s.forEach(function (h2) { scrollObserver.observe(h2); });

  /* ---- 4. PRODUKT-SLIDER INJEKTION NACH 2. H2 ---- */
  const productsBlock = document.getElementById('hh-products-block');

  if (productsBlock && h2s.length >= 2) {
    const secondH2 = h2s[1];
    let insertAfter = secondH2;
    let candidate = secondH2.nextElementSibling;
    let skipCount = 0;

    while (candidate && skipCount < 2) {
      if (candidate.tagName === 'P' || candidate.tagName === 'UL' || candidate.tagName === 'OL') {
        insertAfter = candidate;
        candidate = candidate.nextElementSibling;
        skipCount++;
      } else {
        break;
      }
    }

    insertAfter.after(productsBlock);
requestAnimationFrame(function() {
  productsBlock.classList.add('is-placed');
});


setTimeout(function() {
  productsBlock.querySelectorAll('*').forEach(function(el) {
    const anim = window.getComputedStyle(el).animationName;
    if (anim && anim !== 'none') {
      el.style.animation = 'none';
    }
  });
  productsBlock.querySelectorAll('.motion-item').forEach(function(el) {
    el.style.opacity = '1';
    el.style.transform = 'none';
  });
}, 100);
    productsBlock.querySelectorAll('.motion-item').forEach(function(el) {
  el.classList.add('is-visible');
  el.style.opacity = '1';
  el.style.transform = 'none';
});
  }

  /* ---- 5. FAQ ACCORDION ---- */
  const faqContainer = articleContent.querySelector('.article-faq');

  if (faqContainer) {
    faqContainer.classList.add('hh-faq');
    const h3s = Array.from(faqContainer.querySelectorAll('h3'));

    h3s.forEach(function (h3) {
      const answer = h3.nextElementSibling;
      if (!answer) return;

      const item = document.createElement('div');
      item.className = 'hh-faq__item';

      const btn = document.createElement('button');
      btn.className = 'hh-faq__question';
      btn.setAttribute('type', 'button');
      btn.innerHTML = '<span>' + h3.textContent.trim() + '</span><span class="hh-faq__icon" aria-hidden="true"></span>';

      const answerDiv = document.createElement('div');
      answerDiv.className = 'hh-faq__answer';
      answerDiv.innerHTML = answer.innerHTML;

      btn.addEventListener('click', function () {
        const isOpen = item.classList.contains('is-open');
        faqContainer.querySelectorAll('.hh-faq__item.is-open').forEach(function (i) {
          i.classList.remove('is-open');
        });
        if (!isOpen) item.classList.add('is-open');
      });

      item.appendChild(btn);
      item.appendChild(answerDiv);
      h3.replaceWith(item);
      answer.remove();
    });
  }

})();